export { Link3 as default } from './Link3';
